(function ($, Drupal, once) {
  Drupal.behaviors.carouselNoticiasRecente = {
    attach: function (context, settings) {
      let opts = {
            gap: 10,
            autoWidth: false,
            type: 'slide',
            perPage: 4,
            perMove: 4,
            arrows: false,
            pagination: true,
            autoplay: false,
            interval: 4000,
            autoHeight: false,
            breakpoints: {
                768: { perPage: 1 },
                990: { perPage: 2 },
                1400: { 
                    perPage: 3,
                    gap: 35,
                 }
            }
        };

      once('carouselNoticiasRecente', '.carousel-noticias-recentes.splide', context)
        .forEach(function (element) {
          new Splide(element, opts).mount(window.splide.Extensions);
        });
    }
  };
})(jQuery, Drupal, once);


